import React from 'react'
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'

import styles from './../style/Videos.module.scss'

import { Container, Image, Modal } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import StormcloudButton from './StormcloudButton'
import FeedbackForm from './FeedbackForm'

class Videos extends React.Component {
  constructor(props) {
    super(props)
    this.swiperRef = React.createRef()
    this.nextSlide = this.nextSlide.bind(this)
    this.prevSlide = this.prevSlide.bind(this)
    this.state = {
      show_feedback: false,
      show_video_modal: false,
      activeIndex: 0,
      currentVideo: null
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  openVideoModal = (video) => {
    this.setState({ 
      show_video_modal: true,
      currentVideo: video
    });
  }

  closeVideoModal = () => {
    this.setState({ 
      show_video_modal: false,
      currentVideo: null
    });
  }

  nextSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slideNext()
    }
  }

  prevSlide() {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.swiperRef.current.swiper.slidePrev()
    }
  }

  handleSlideChange = () => {
    if (this.swiperRef.current && this.swiperRef.current.swiper) {
      this.setState({
        activeIndex: this.swiperRef.current.swiper.realIndex
      })
    }
  }

  formatSlideNumber = (index) => {
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  extractRutubeVideoId(url) {
      // Функция для извлечения ID видео из Rutube URL
      if (!url) return null;
      
      // Для ссылки вида: https://rutube.ru/video/a8dbc0f7ad3db205eca295af373591c6/
      const regExp1 = /rutube\.ru\/video\/([a-zA-Z0-9]+)/;
      // Для embed ссылки: https://rutube.ru/play/embed/a8dbc0f7ad3db205eca295af373591c6/
      const regExp2 = /rutube\.ru\/play\/embed\/([a-zA-Z0-9]+)/;
      // Для shorts ссылки: https://rutube.ru/shorts/0c308cf431ceb17c6b13ac1f59a4403a/
      const regExp3 = /rutube\.ru\/shorts\/([a-zA-Z0-9]+)/;
      
      const match1 = url.match(regExp1);
      const match2 = url.match(regExp2);
      const match3 = url.match(regExp3);
      
      if (match1 && match1[1]) return match1[1];
      if (match2 && match2[1]) return match2[1];
      if (match3 && match3[1]) return match3[1];
      
      return null;
  }

  getRutubeEmbedUrl(videoId) {
      if (!videoId) return null;
      return `https://rutube.ru/play/embed/${videoId}/`;
  }

  render() {
    const { data } = this.props;
    const { show_feedback, show_video_modal, currentVideo } = this.state;

    const videoId = currentVideo ? this.extractRutubeVideoId(currentVideo.link) : null;
    const embedUrl = videoId ? this.getRutubeEmbedUrl(videoId) : '';

    return (
      <section className={styles.section}>
        <Container>
          <WhiteBlockTitle
            title={data?.title || ``}
            text={``}
            rcusom={(
              <StormcloudButton
                text={`Узнать подробнее о продуктах на видео`}
                svg={(
                  <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.09082 7.90998L7.909 1.0918M7.909 1.0918H2.45446M7.909 1.0918V6.54634" stroke="#3E4C5A" strokeLinecap="round"/>
                  </svg>
                )}
                width={271}
                action={() => { this.showFeedback() }}
              />
            )}
            className={styles.title}
          />
          
          <FeedbackForm
            title={`Узнать подробнее о продуктах на видео`}
            text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
            btn={`Отправить`}
            data={[]}
            show={show_feedback}
            handleClose={() => this.closeFeedback()}
          />

          {/* Модальное окно для видео */}
          <Modal 
            show={show_video_modal} 
            onHide={this.closeVideoModal}
            size="lg"
            centered
            className={styles.video_modal}
          >
            <Modal.Header closeButton>
              <Modal.Title>{currentVideo?.name || 'Видео'}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="p-0">
              {embedUrl ? (
                <div className={styles.video_container}>
                  <iframe
                    src={embedUrl}
                    width="100%"
                    height="405"
                    frameBorder="0"
                    style={{ border: 'none' }}
                    allow="clipboard-write; autoplay"
                    webkitAllowFullScreen
                    mozallowfullscreen
                    allowFullScreen
                    title={currentVideo?.name || 'Видео'}
                  />
                </div>
              ) : (
                <p>Неверная ссылка на видео</p>
              )}
            </Modal.Body>
          </Modal>

          <div className={styles.swiper_container}>
            <Swiper
              ref={this.swiperRef}
              modules={[Navigation]}
              spaceBetween={10}
              slidesPerView={2}
              loop={true}
              onSlideChange={this.handleSlideChange}
              onSwiper={(swiper) => {
                this.setState({ activeIndex: swiper.realIndex })
              }}
            >
              {data?.list.map( ( slyde, index ) => (
                <SwiperSlide key={index}>
                  <div className={styles.slyde}>
                    <div className={styles.slyde_img}>
                      <Image src={slyde?.image} alt={slyde?.name} width={585} height={295} />
                      <div className={styles.slyde_head}>
                        <div>GOODWIN</div>
                        <div className={styles.slyde_head_sep} />
                        <div>{this.formatSlideNumber(index)}</div>
                      </div>
                      <div 
                        className={styles.slyde_btn} 
                        onClick={() => this.openVideoModal(slyde)}
                        role="button"
                        tabIndex={0}
                        onKeyUp={(e) => e.key === 'Enter' && this.openVideoModal(slyde)}
                      >
                        <GreenButton
                          text={`Смотреть видео`}
                          width={145}
                          svg={(
                            <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.5 4.63397C9.16667 5.01888 9.16667 5.98113 8.5 6.36603L1.75 10.2631C1.08333 10.648 0.25 10.1669 0.25 9.39711L0.250001 1.60289C0.250001 0.833085 1.08333 0.35196 1.75 0.73686L8.5 4.63397Z" fill="#00C775"/>
                            </svg>
                          )}
                        />
                      </div>
                    </div>
                    <div className={styles.slyde_type}>{slyde?.type}</div>
                    <div className={styles.slyde_name}>{slyde?.name}</div>
                  </div>
                </SwiperSlide>
              ) )}
            </Swiper>
            <div className={styles.slydenav_btns}>
              <div></div>
              <div className={styles.slydenav_btn} onClick={this.nextSlide}>
                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.678817 4.50087H10.3212M10.3212 4.50087L6.46424 0.643924M10.3212 4.50087L6.46424 8.35782" stroke="white" strokeLinecap="round" />
                </svg>
              </div>
            </div>
          </div>
        </Container>
      </section>
    )
  }
}

Videos.propTypes = {
  data: PropTypes.object
}

Videos.defaultProps = {
  data: {}
}

export default Videos